module.exports = __webpack_public_path__ + "images/emoji/bowling.8a61fe950778c2c904ff.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bowling.png
// module id = RC5Y
// module chunks = 13